import { render, staticRenderFns } from "./Datetime.token.vue?vue&type=template&id=850d1fbe&"
import script from "./Datetime.token.vue?vue&type=script&lang=ts&"
export * from "./Datetime.token.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports